export const submitLead = async (payload) => {
  const lead = {
    ...payload,
    id: `${Date.now()}-${Math.floor(Math.random() * 100000)}`,
    submittedAt: new Date().toISOString(),
  };

  const googleScriptUrl = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

  if (!googleScriptUrl) {
    throw new Error("Google Script URL is not configured");
  }

  await fetch(googleScriptUrl, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: new URLSearchParams(
      Object.entries(lead).map(([key, value]) => [key, String(value)])
    ),
  });

  return {
    ...lead,
    delivery: "google-sheets",
  };
};
